import React, { useCallback, useMemo, useState } from 'react';

// Components
import Fuse from 'fuse.js';
import _ from 'lodash';
import { SuperUserMemberList } from './super-user-member-list.component';
import { IHighLevelMemberListContainer } from './member-list.types';


export const HighLevelMemberListContainer: React.FC<IHighLevelMemberListContainer> = ({
  members,
  restoreMemberAccess,
  revokeMemberAccess,
  updateMemberRoles,
  onViewAgeGroups,
  activeAgeGroupUserId,
  ...rest
}) => {
  const [selected, setSelected] = useState<IMember[]>([]);

  const [searchTerm, setSearchTerm] = useState('');
  // Derived in render, never copied into state, so a role save shows in the same frame as the cache write.
  const filteredMembers = useMemo(() => {
    if (!searchTerm.length) return members;

    const fuse = new Fuse(members, { threshold: 0.3, keys: ['user.name', 'user.email'] });
    return _.map(fuse.search(searchTerm), 'item');
  }, [members, searchTerm]);

  const debounceSearch = useCallback(_.debounce((nextSearch: string) => {
    setSearchTerm(nextSearch)
  }, 300), []);

  const onRevokeAccess = useCallback((_ids: string[], ageGroupId?: string) =>
    _ids.map(_id => revokeMemberAccess(_id, ageGroupId)), [revokeMemberAccess]);

  const onRestoreAccess = useCallback((_ids: string[], ageGroupId?: string) =>
    _ids.map(_id => restoreMemberAccess(_id, ageGroupId)), [restoreMemberAccess]);

  return <SuperUserMemberList
    {...rest}
    revokeAccess={onRevokeAccess}
    restoreAccess={onRestoreAccess}
    members={filteredMembers || []}
    search={debounceSearch}
    selected={selected}
    setSelected={setSelected}
    updateMemberRoles={updateMemberRoles}
    onViewAgeGroups={onViewAgeGroups}
    activeAgeGroupUserId={activeAgeGroupUserId}
  />;
};
